import { z } from 'zod';
import {
  contactPersonSchema,
  createModel,
  currencySchema,
  legalEntitySchema,
  membersCountSchema,
  partyRoleSchema,
  statusCommonSchema,
} from '../../common';
import { integerSchema, nameSchema } from '../../validation';
import { carrierVehicleCount } from './carrier.vehicle.model';
import { UTagSharedSchema } from '../utag';

/**
 * `carrier db model`
 *
 * @deprecated **Relations-v2 transition** — the legacy `Carrier` and
 * `Business` collections are being unified into the new `Org` collection
 * (Phase 3 dual-write begins; legacy collections removed per the
 * future-cleanup roadmap). Kept here so existing readers and tooling
 * keep working during Phases 1–6. NEW writes SHOULD go through the
 * `Org` collection and the `Party` builder family
 * (see `PartyResolverService.makeParty`).
 *
 * Removal is scheduled in
 * {@link file://./../../../../../../docs/relations-v2/05-future-cleanup-roadmap.md `docs/relations-v2/05-future-cleanup-roadmap.md`}.
 * See also `docs/relations-v2/07-collection-unification.md` for the
 * Business+Carrier → Org migration plan.
 */
export const CarrierSchema = createModel({
  /** the display of the carrier name */
  name: nameSchema,
  /** the status of teh carrier active/inactive/etc */
  status: statusCommonSchema,
  /** the types & count of carrier vehicles (given by the user when signup) */
  vehicles: carrierVehicleCount,

  legal: legalEntitySchema.optional(),
  /** the actual vehicle count ... this is incremented every time a new vehicle is added to the system which belongs to this carrier */
  actualVehiclesCount: integerSchema,
  /** the primary contact at for the carrier */
  primaryContact: contactPersonSchema,
  /** the currency of the carrier he wants to be paid in */
  currency: currencySchema,
  /** a count of any member related  to the carrier such as drivers / employees / managers*/
  members: membersCountSchema,
  UTags: z.array(UTagSharedSchema),
  /**
   * the network roles this Carrier plays. Defaults to `['carrier']`
   * during the transition; multi-role Orgs (customer + carrier + broker)
   * are tracked on the new `Org` collection — see
   * `docs/relations-v2/07-collection-unification.md`. ≥ 1.
   */
  roles: z.array(partyRoleSchema).min(1),
});

/**
 * `carrier db model`
 *
 * @deprecated See {@link CarrierSchema}. Use `Org` for new code.
 */
export type Carrier = z.infer<typeof CarrierSchema.model>;
/** @deprecated See {@link CarrierSchema}. Use `Org` for new code. */
export type CarrierData = z.infer<typeof CarrierSchema.data>;
/** @deprecated See {@link CarrierSchema}. Use `Org` for new code. */
export type CarrierPartial = z.infer<typeof CarrierSchema.partial>;
